module.exports = __webpack_public_path__ + "img/Bildschirmfoto 2021-11-25 um 21.38.26.bb7d3bb8.png";